
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 81 80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41 0C19.022 0 1 17.988 1 40c0 22.025 17.98 40 40 40 21.923 0 40-17.905 40-40 0-10.64-4.281-20.625-11.828-28.172C61.625 4.281 51.64 0 41 0zm0 70.469c-16.842 0-30.469-13.59-30.469-30.469 0-6.563 2.063-12.797 5.86-17.953l42.562 42.516c-5.156 3.843-11.39 5.906-17.953 5.906zm24.563-12.516L23.047 15.391C28.203 11.594 34.437 9.53 41 9.53c16.842 0 30.469 13.592 30.469 30.469 0 6.563-2.063 12.797-5.906 17.953z","fill":"#EB5757"}})])
          )
        }
      }
    